export default "__VITE_ASSET__Dh$_zX$i__"